import React, { useContext } from "react";
import { AutomationSection } from "../../context/AutomationContext";
import { AutomationFirstPage, AutomationIfPage, AutomationElsePage } from "./";

const Automation = () => {
  const { automationPage } = useContext(AutomationSection);

  return (
    <div>
      <div className="d-flex align-items-center weatherStatus mb-4">
        <i className="circleTop icon-plug text-center mx-2"></i>
        <div className="text-center mr-4">
          <p className="m-0">اتوماسیون</p>
        </div>
      </div>

      <div style={{ minHeight: "80vh" }} className="">
        {automationPage.firstPage && <AutomationFirstPage />}
        {automationPage.ifPage && <AutomationIfPage />}
        {automationPage.elsePage && <AutomationElsePage />}
      </div>
    </div>
  );
};

export { Automation };
